module.exports = __webpack_public_path__ + "img/flex5_3_Extended-front.99109b1f.jpg";